<script setup lang="ts">
import type { SearchResultTypes } from "~/types/Search";

const props = defineProps<{ type: SearchResultTypes }>();

const localePath = useLocalePath();
const route = useRoute();

const searchTerm = computed(() => route.params.searchTerm);

const onViewAllClicked = async () => {
  await navigateTo(
    localePath({
      path: `/search/${searchTerm.value}/${props.type}`,
    }),
  );
};
</script>

<template>
  <div class="search-result-page-sub-header">
    <h2 class="uppercase">
      {{ $t(`searchResults.${type}`) }}
    </h2>
    <button
      class="hidden uppercase md:block"
      :data-cy="`search-results-page-view-all-${type}`"
      @click="onViewAllClicked"
    >
      {{ $t("searchResults.viewAll") }}
    </button>
  </div>
</template>

<style scoped lang="postcss">
.search-result-page-sub-header {
  @apply flex flex-row justify-between font-bold;
  @apply pb-2 px-4 md:px-0 md:pb-0;
}
</style>
